import {
  API,
  API_ACCESS_DENIED,
  API_ERROR
} from '../actionTypes'

export const apiAction = ({
  url = "",
  method = "GET",
  data = null,
  params = null,
  onSuccess = () => {},
  onFailure = () => {},
  label = "",
  resourceType = "",
  resourceId = null
}) => {
  return {
    type: API,
    payload: {
      url,
      method,
      data,
      params,
      onSuccess,
      onFailure,
      label,
      resourceType,
      resourceId
    }
  }
}

export const accessDenied = url => ({
  type: API_ACCESS_DENIED,
  payload: {
    url
  }
})

export const apiError = (label, error) => ({
  type: API_ERROR,
  label,
  error
})